var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "Sidebar Basic"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeBasic) + " ")];
      },
      proxy: true
    }])
  }, [_c('b-card-text', [_c('span', [_vm._v("BootstrapVue's custom ")]), _c('code', [_vm._v("<b-sidebar>")]), _c('span', [_vm._v(" component is a fixed-position toggleable slide out box, which can be used for navigation, menus, details, etc.")])]), _c('div', [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(113, 102, 240, 0.15)',
      expression: "'rgba(113, 102, 240, 0.15)'",
      modifiers: {
        "400": true
      }
    }, {
      name: "b-toggle",
      rawName: "v-b-toggle.sidebar-1",
      modifiers: {
        "sidebar-1": true
      }
    }],
    attrs: {
      "variant": "outline-primary"
    }
  }, [_vm._v(" Toggle Sidebar ")]), _c('b-sidebar', {
    attrs: {
      "id": "sidebar-1",
      "shadow": "",
      "bg-variant": "white",
      "backdrop": ""
    }
  }, [_c('sidebar-content')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }